import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import { createElement, MouseEvent, MouseEventHandler, useContext, FC } from 'react';
import { context as Historycontext } from '../../../context/history';

type Props = TypographyProps & {
  href: string;
  state?: {
    scroll: boolean;
  };
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  withNewTab?: boolean;
  className?: string;
};

const RouterLink: FC<Props> = ({ href, state = { scroll: true }, withNewTab, onClick, className, ...otherProps }) => {
  const history = useContext(Historycontext);

  return (
    <Typography
      {...otherProps as any}
      component="a"
      href={href}
      target={withNewTab ? '_blank' : undefined}
      rel={withNewTab ? 'noopener' : undefined}
      onClick={(e: MouseEvent<HTMLElement>) => {
        if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
        if (href.startsWith('http')) return;

        e.preventDefault();

        history.push(href, state);

        if (onClick) onClick(e);
      }}
      className={className}
    />
  );
};

export default RouterLink;
